/**
 * Newsletter Bottombar
 * 
 * @dependencies
 * * toolkit.getLocalStorageObject (toolkit.js)
 * * toolkit.setLocalStorageObject (toolkit.js)
 * 
 * @dependents
 * * $(document).ready(function()
 * 
 * @commit 
 * * s.schaefermeier (2018-03-16): update from gw2.erco.org
 * * h.bode (2020-03)
 */


NewsletterBottom = {

  // save current active element
  currentActiveElement: document.activeElement,
  newsletterBottomBarElement: null,
  newsletterBottomBarContainer: null,

  submitNewsletterForm: null,
  submitNewsletterFormInputs: null,
  submitNewsletterFormSelect: null,
  
  submitNewsletterFormButton: null,
  closeNewsletterBottomBarButton: null,
  
  closeNewsletterBottomBarLink: null,

  errorMessageElement: null,
  errorHideTimeout: null,

  sendingRequest: false,
  submitSuccess: false,

  // Checking the cookies if the bottombar should be displayed or not
  init: function () {
    // Init references to DOM elements
    this.newsletterBottomBarElement = document.querySelector('#newsletter-bottom-bar');
    if(!this.newsletterBottomBarElement) {
      return;
    }
    this.newsletterBottomBarContainer = this.newsletterBottomBarElement.querySelector('.newsletter-bottom-bar__container');

    this.submitNewsletterForm = document.querySelector('form[name="submit_newsletter"]');
    if(!this.submitNewsletterForm) {
      return;
    }
    this.submitNewsletterFormInputs = this.submitNewsletterForm.querySelectorAll('input');
    this.submitNewsletterFormSelect = this.submitNewsletterForm.querySelector('select');

    this.submitNewsletterFormButton = document.querySelector('#submit_newsletter');
    this.closeNewsletterBottomBarButton = document.querySelector('#newsletter-bottom-bar [data-js-newsletter-close]');

    this.closeNewsletterBottomBarLink = document.createElement('a');
    this.closeNewsletterBottomBarLink.href = '#';
    this.closeNewsletterBottomBarLink.className = 'btn invers';
    this.closeNewsletterBottomBarLink.setAttribute('data-js-newsletter-close', '');

    this.errorMessageElement = document.querySelector('#newsletter-error-message');

    // Init sending and success flag
    this.sendingRequest = false;
    this.submitSuccess = false;

    // Reading visitCount object from localStorage
    let visitCountStorageObject = window.toolkit.getLocalStorageObject('visitCount');

    // Reading the newsletterSubmitted object from localStorage
    let newsletterSubmittedStorageObject = window.toolkit.getLocalStorageObject('newsletterSubmitted');

    // Setting the visitCount object in localStorage if it does not exist, otherwise incrementing it
    if (visitCountStorageObject === null) {
      visitCountStorageObject = { counter: 1 };
      window.toolkit.setLocalStorageObject('visitCount', visitCountStorageObject, 24 * 60); // expires in 24 hours
    } else {
      visitCountStorageObject.counter++;
      window.toolkit.setLocalStorageObject('visitCount', visitCountStorageObject, 24 * 60); // expires in 24 hours
    }

    // Setting the newsletterSubmitted object in localStorage if it does not exist
    if (newsletterSubmittedStorageObject === null) {
      newsletterSubmittedStorageObject = { submitted: false };
      window.toolkit.setLocalStorageObject('newsletterSubmitted', newsletterSubmittedStorageObject, 7 * 24 * 60); // expires in 1 week
    }

    // Showing the container after x ms during the first three visits or if the corresponding data tag is present
    // prevent showing the bottom-bar if data-newsletter-bottom-bar-disable is present
    if (
      (visitCountStorageObject.counter <= 3
        && !newsletterSubmittedStorageObject.submitted
        || document.querySelector('[data-newsletter-active]'))
      && !document.querySelector('[data-newsletter-bottom-bar-disable]')
    ) {
      setTimeout(() => {
        this.currentActiveElement = document.activeElement;

        this.newsletterBottomBarElement.removeAttribute('hidden');
        this.newsletterBottomBarElement.classList.add('active');
        this.newsletterBottomBarElement.setAttribute('inert', '');

        const onShown = () => {
          this.newsletterBottomBarElement.removeAttribute('inert');
          this.newsletterBottomBarElement.setAttribute('aria-hidden', 'false');
          this.newsletterBottomBarElement.removeEventListener('transitionend', onShown);

          // Closing the bar if we are at the bottom of the website as to not overlay the footer
          this.checkScrollPosition();
        };

        const cs = window.getComputedStyle(this.newsletterBottomBarElement);
        const hasTransition = parseFloat(cs.transitionDuration) > 0 || parseFloat(cs.transitionDelay) > 0;
        hasTransition ? this.newsletterBottomBarElement.addEventListener('transitionend', onShown) : onShown();
      }, 5000);
    }

    // Extending the newsletterbar when its active
    this.newsletterBottomBarElement.addEventListener('click', (e) => {
      if (this.submitSuccess) return;
      e.currentTarget.classList.add('extended');
    });

    // Extending the newsletterbar when its focussed
    this.newsletterBottomBarElement.addEventListener('focusin', (e) => {
      // prevent extending when clicking the close button
      if (e.target === this.closeNewsletterBottomBarButton || this.submitSuccess) return;
      e.currentTarget.classList.add('extended');
    });

    this.submitNewsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });

    [this.closeNewsletterBottomBarButton, this.closeNewsletterBottomBarLink].forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    });
  },

  // Closing the bottombar and hiding it for a week
  close: function () {

    // Creating the newsletterSubmitted object
    const newsletterSubmittedStorageObject = { submitted: true };
    window.toolkit.setLocalStorageObject('newsletterSubmitted', newsletterSubmittedStorageObject, 7 * 24 * 60); // expires in 1 week

    this.newsletterBottomBarElement.setAttribute('inert', '');
    
    this.newsletterBottomBarElement.classList.remove('active', 'extended');

    this.hideErrorMessage();

    setTimeout(() => {
      this.newsletterBottomBarElement.setAttribute('hidden', '');
      this.newsletterBottomBarElement.setAttribute('aria-hidden', 'true');
    }, 300);

    // move focus back to the header
    const header = document.querySelector('header');
    if (this.currentActiveElement) {
      this.currentActiveElement.focus();
    } else {
      header?.focus();
    }

    window.removeEventListener('scroll', NewsletterBottom.handleScroll);
  },

  validEmail: function (email) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(email);
  },

  // Validating the bottombar input before sending
  valid: function () {

    var valid = true;

    // Looping through all form elements and checking if they are empty
    this.submitNewsletterFormInputs.forEach((input) => {
      if (input.getAttribute('name') === 'email') {
        if (!this.validEmail(input.value)) {
          valid = false;
          input.classList.add('empty');
        }
      }
    });

    return valid;
  },

  // Submitting the newsletter subscriber
  submit: function () {
    if (this.sendingRequest) {
      return;
    }

    this.hideErrorMessage();

    this.sendingRequest = true;
    this.submitSuccess = false;

    // Checking if the input is valid
    if (!NewsletterBottom.valid()) {
      this.sendingRequest = false;
      return;
    }

    // Showing the spinner
    this.submitNewsletterFormButton.classList.add('sending');

    var payload = {};

    // Grabbing the userinput
    this.submitNewsletterFormInputs.forEach((input) => {
      payload[input.getAttribute('name')] = input.value;
    });

    payload.lang = this.submitNewsletterFormSelect ? this.submitNewsletterFormSelect.value : undefined;
    payload.type = 'newsletterbottombar';

    newsletter.subscribeNewsletter(payload, (res) => {
      // Removing the spinner
      this.submitNewsletterFormButton.classList.remove('sending');

      // Resetting sending flag to allow new submissions
      this.sendingRequest = false;
      
      if (!res || !res.success) {
        this.showErrorMessage();
        return;
      }

      this.submitSuccess = true;

      // Fading the content out and the message in
      this.newsletterBottomBarContainer.classList.add('trans');
      this.newsletterBottomBarElement.classList.remove('extended');
      this.newsletterBottomBarElement.classList.add('submitted');

      setTimeout(() => {
        this.showSuccessMessage(res.message, res.close);
        this.newsletterBottomBarContainer.classList.remove('trans');

        // Setting the newsletterSubmitted object in localStorage, therefore hiding the newsletter bottombar for a week
        const newsletterSubmittedStorageObject = { submitted: true };
        window.toolkit.setLocalStorageObject('newsletterSubmitted', newsletterSubmittedStorageObject, 7 * 24 * 60); // expires in 1 week

        // Hiding the newsletter bar after x Seconds
        setTimeout(() => {
          this.newsletterBottomBarElement.classList.remove('active');
        }, 10000);

      }, 500);
    });
  },

  showSuccessMessage: function(message, closeText) {
    const successMessage = document.createElement('p');
    successMessage.className = 'user_message';
    successMessage.innerHTML = message;
    this.newsletterBottomBarContainer.innerHTML = '';
    this.newsletterBottomBarContainer.appendChild(successMessage);
    this.closeNewsletterBottomBarLink.textContent = closeText;
    this.newsletterBottomBarContainer.appendChild(this.closeNewsletterBottomBarLink);
  },

  showErrorMessage: function () {
    clearTimeout(this.errorHideTimeout);
    this.errorMessageElement.firstElementChild.classList.remove("d-n");
    this.errorHideTimeout = setTimeout(() => {
      this.hideErrorMessage();
    }, 10000);
  },

  hideErrorMessage: function () {
    clearTimeout(this.errorHideTimeout);
    this.errorMessageElement.firstElementChild.classList.add("d-n");
  },

  // Checking if we are scrolled to the bottom of the page
  checkScrollPosition: function () {
    window.addEventListener('scroll', NewsletterBottom.handleScroll);
  },

  handleScroll: function (e) {
    if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 100) {
      NewsletterBottom.close();
    }
  },
}
